import { Component, ElementRef, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationsService } from './notifications.service';
import { Notification } from './notifications.model';


@Component({
    selector: 'notifications',
    standalone: false,
    template:`
    <div class="notifications" style="position:fixed">    
        <div (click)="hide(note, note.type != 'exception')" class="{{ note.type }}"
                *ngFor="let note of _notes">   
            {{ note.message }}
            <a class="notification-close"
                [hidden]="note.type != 'exception'"
                title="close"
                (click)="hide(note, false, $event)">

                    <i class="material-icons">close</i>
            </a>
        </div>
    </div>
    `
})
export class NotificationComponent implements OnInit {
    
    private element: any;    
    public _notes: Notification[];

    constructor(
        private _notifications: NotificationsService,
        private _router: Router,
        private _el: ElementRef,
        private cd: ChangeDetectorRef,
        private ngZone: NgZone
    ) {
        this.element = _el.nativeElement;        
        this._notes = new Array<Notification>();

        _notifications.noteAdded.subscribe(note => {
            this.ngZone.run(() => {
                this._notes.push(note);
                if(note.type=='exception')
                {
                    if (note.description){
                        note.message = note.description + '. ' + note.message;    
                    }else{
                        note.message="Apologies, something went wrong, please mention the following error/code when requesting help: "+ note.message;
                    }
                }
                else if (note.type === 'warn'){
                    if (note.description){
                        note.message = note.description + '. ' + note.message;    
                    }else{
                        note.message= (note.includePremessage ? "Mmmh... something does not seem right, please mention the following error/code when requesting help: " : "") + note.message;
                    }
                }else
                {
                    setTimeout(() => { this.hide.bind(this)(note) }, 5000);
                }
                this.cd.detectChanges();
            });
        });
        _router.events.subscribe(ev => {
           if(this._notes && this._notes.findIndex(note=>note.type=='exception')>=0)
           {
               var exNotes= this._notes.filter(note=>note.type=='exception');
               if(exNotes)
               exNotes.forEach(note=>this.hide(note));
           }
        });
    }

    ngOnInit(): void {
        //this.element.appendTo('body');
        this.initMaterial();
    }
    ngAfterViewInit() {
        // SharedUtils.RemoveTooltipIfNeeded();
        // $('.collapsible').collapsible();
        
      }
            initMaterial() {
                // Materialize.updateTextFields(); // Eliminado: no es necesario con Angular Material
            }
    public hide(note, notAnException: Boolean = true) {
        // Siempre eliminar la notificación
        let index = this._notes.indexOf(note);
        if (index >= 0) {
            this._notes.splice(index, 1);
            this.cd.detectChanges();
        }
    }
}